import { c as _c } from "react/compiler-runtime";
import { Avatar, Button, Text, VStack } from '@chakra-ui/react';
import { bookMeetingHrefForAdvisor, bookMeetingLabelForAdvisor, LockedTeamAdvisor } from '@src/components/sco/Advisors/model/access';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { PaywalledAdvisorAction } from '@src/components/sco/Advisors/shared/PaywalledAdvisorAction';
import { SpecialtyTag } from '@src/components/sco/Advisors/shared/SpecialtyTag';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { LuCalendar, LuMessageSquare } from 'react-icons/lu';

/** Right-rail profile for a locked Startups.com team advisor (static roster). */
export const LockedTeamAdvisorMiniProfile = t0 => {
  const $ = _c(50);
  const {
    advisor
  } = t0;
  const paths = useAdvisorsPaths();
  const profileHref = advisor.userId ? `/members/${advisor.userId}` : undefined;
  let t1;
  if ($[0] !== advisor.name || $[1] !== advisor.navKey || $[2] !== advisor.userId) {
    t1 = bookMeetingHrefForAdvisor({
      name: advisor.name,
      userId: advisor.userId,
      navKey: advisor.navKey
    });
    $[0] = advisor.name;
    $[1] = advisor.navKey;
    $[2] = advisor.userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const bookMeetingHref = t1;
  let t2;
  if ($[4] !== advisor.name) {
    t2 = bookMeetingLabelForAdvisor(advisor.name);
    $[4] = advisor.name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const bookMeetingLabel = t2;
  let t3;
  if ($[6] !== advisor.navKey || $[7] !== paths) {
    t3 = paths.withQuery(paths.inbox, {
      advisorKey: advisor.navKey
    });
    $[6] = advisor.navKey;
    $[7] = paths;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const messageHref = t3;
  let t4;
  if ($[9] !== advisor.name) {
    t4 = <Avatar.Fallback name={advisor.name} />;
    $[9] = advisor.name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== advisor.avatarUrl) {
    t5 = <Avatar.Image src={advisor.avatarUrl} />;
    $[11] = advisor.avatarUrl;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== advisor.categoryColor || $[14] !== t4 || $[15] !== t5) {
    t6 = <Avatar.Root colorPalette={advisor.categoryColor} size="2xl">{t4}{t5}</Avatar.Root>;
    $[13] = advisor.categoryColor;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== advisor.name) {
    t7 = <Text fontSize="lg" fontWeight="semibold" lineHeight="short">{advisor.name}</Text>;
    $[17] = advisor.name;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== advisor.category || $[20] !== advisor.categoryColor) {
    t8 = <SpecialtyTag colorPalette={advisor.categoryColor} label={advisor.category} />;
    $[19] = advisor.category;
    $[20] = advisor.categoryColor;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== advisor.role) {
    t9 = <Text color="colorPalette.fg/60" fontSize="xs">{advisor.role} · Startups.com</Text>;
    $[22] = advisor.role;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <VStack gap={1}>{t7}{t8}{t9}</VStack>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t6) {
    t11 = <VStack align="center" gap={2} textAlign="center">{t6}{t10}</VStack>;
    $[28] = t10;
    $[29] = t6;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== advisor.bio) {
    t12 = <Text color="colorPalette.fg/70" fontSize="sm" lineClamp={4} textAlign="center">{advisor.bio}</Text>;
    $[31] = advisor.bio;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      size: "sm",
      width: "full"
    };
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <LuMessageSquare />;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== messageHref) {
    t15 = <PaywalledAdvisorAction isTeamAdvisor={true} upgradeCtaButtonProps={t13}><Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={messageHref}>{t14}Message</NextLink></Button></PaywalledAdvisorAction>;
    $[35] = messageHref;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== bookMeetingHref || $[38] !== bookMeetingLabel) {
    t16 = bookMeetingHref ? <Button asChild={true} size="sm" variant="outline" width="full"><a href={bookMeetingHref} rel="noopener noreferrer" target="_blank"><LuCalendar />{bookMeetingLabel}</a></Button> : null;
    $[37] = bookMeetingHref;
    $[38] = bookMeetingLabel;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== profileHref) {
    t17 = profileHref ? <Button asChild={true} size="sm" variant="ghost" width="full"><NextLink href={profileHref}>View full profile</NextLink></Button> : null;
    $[40] = profileHref;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t15 || $[43] !== t16 || $[44] !== t17) {
    t18 = <VStack align="stretch" gap={2}>{t15}{t16}{t17}</VStack>;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t11 || $[47] !== t12 || $[48] !== t18) {
    t19 = <VStack align="stretch" gap={4} width="full">{t11}{t12}{t18}</VStack>;
    $[46] = t11;
    $[47] = t12;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  return t19;
};